import { FieldValidator } from './field-validator'
import { isPoBox } from '../utils/is-po-box'

export class NotPoBoxAddressTextFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (isPoBox(text)) {
                reject(`${fieldName} cannot be a PO Box`)
            } else {
                resolve('')
            }
        })
    }
}
